import type { MediaDto } from "@/types";

interface Props {
  media: MediaDto;
  className?: string;
  sizes?: string;
  loading?: "lazy" | "eager";
}

/**
 * <picture> wrapper that prefers WebP when available and degrades to the JPEG variants.
 */
export function ResponsiveImage({ media, className, sizes, loading = "lazy" }: Props) {
  const jpgSrcset = `${media.urlSm} 480w, ${media.urlMd} 1024w, ${media.urlLg} 1920w`;
  const webpSrcset = `${media.urlSmWebp} 480w, ${media.urlMdWebp} 1024w, ${media.urlLgWebp} 1920w`;
  return (
    <picture>
      {media.urlSmWebp && <source type="image/webp" srcSet={webpSrcset} sizes={sizes} />}
      <img
        src={media.urlMd}
        srcSet={jpgSrcset}
        sizes={sizes}
        alt={media.alt ?? ""}
        loading={loading}
        decoding="async"
        width={media.width ?? undefined}
        height={media.height ?? undefined}
        className={className}
      />
    </picture>
  );
}
